export const FETCH_ALL_TECHNICIANS = "[RECEPTIONIST] FETCH_ALL_TECHNICIANS";
export const FETCH_ALL_TECHNICIANS_START = "[RECEPTIONIST] FETCH_ALL_TECHNICIANS_START";
export const FETCH_ALL_TECHNICIANS_SUCCESS = "[RECEPTIONIST] FETCH_ALL_TECHNICIANS_SUCCESS";
export const FETCH_ALL_TECHNICIANS_ERROR = "[RECEPTIONIST] FETCH_ALL_TECHNICIANS_ERROR";

export const fetchAllTechnicians = () => {
    return {
        type: FETCH_ALL_TECHNICIANS,
    }
}